export type NovaFlavour = {
  id: 'deep-space' | 'ancient-spark' | 'event-horizon'
  code: string
  name: string
  shortName: string
  frequency: string
  description: string
  accent: string
  accentBright: string
  shadow: string
  field: string
  star: string
}

export const NOVA_FLAVOURS: readonly NovaFlavour[] = [
  {
    id: 'deep-space',
    code: 'NVA-01',
    name: 'Deep Space',
    shortName: 'Space',
    frequency: 'Ultraviolet',
    description: 'The original signal. Cold violet, bright after dark.',
    accent: '#8248ff',
    accentBright: '#b386ff',
    shadow: '#080513',
    field: '#281054',
    star: '#6fa8ff',
  },
  {
    id: 'ancient-spark',
    code: 'NVA-02',
    name: 'Ancient Spark',
    shortName: 'Spark',
    frequency: 'Ion blue',
    description: 'Older than fire. A constant and endless explosion.',
    accent: '#43cfff',
    accentBright: '#a9edff',
    shadow: '#03101f',
    field: '#073d78',
    star: '#d5f8ff',
  },
  {
    id: 'event-horizon',
    code: 'NVA-03',
    name: 'Event Horizon',
    shortName: 'Horizon',
    frequency: 'Massive orange',
    description: 'Black pressure. Orange flare. As deadly as quiet.',
    accent: '#ff6a1a',
    accentBright: '#ffb067',
    shadow: '#0b0704',
    field: '#5a1c08',
    star: '#ffd0a1',
  },
] as const
